<div [hidden]="showArivisPreviewer" class="starter-wrapper row h-100">
    <div class="col-md-6 left-column h-100 border-color">
        <div *ngIf="!isRerun && !isWorkflowRunning && !isRunCompleted && !isRunFailed && !isRunPending" class="h-100">
            <ca-file-explorer
                *ngIf="workflowStarterType === WorkflowStarterType.FileExplorerApeerFiles"
                [startInTab]="fileExplorerStartingTab"
                [currentView]="isInRunner === true ? 'runner' : 'dataset'"
                [tabsToHide]="tabsToHide"
                (onFileSelected)="handleSelectFile($event)"
                (onMultipleFilesSelected)="addToSelectedFiles($event, true)"
                (onButtonClicked)="setWorkflowStarterType(WorkflowStarterType.SelectionMethods)"
                data-uit="workflow-starter_file-explorer"
            ></ca-file-explorer>
            <div
                class="selection-methods w-100 h-100"
                data-ui="workflow-starter-selection-methods"
                *ngIf="workflowStarterType === WorkflowStarterType.SelectionMethods"
            >
                <ca-file-upload
                    (click)="setWorkflowStarterType(WorkflowStarterType.SelectionMethods)"
                    [blobType]="userFileBlobType"
                    [allowMultipleFiles]="allowMultipleFiles"
                    [uploaderKey]="uploaderKey"
                    [maxInputSizeInBytes]="maxFileSizeInBytes"
                    [showGeneralMaxInputSizeMessage]="false"
                    [supportedFileTypes]="supportedFileTypes"
                    [notSupportedFileTypeCustomMessage]="notSupportedFileTypeCustomMessage"
                    [errorNotificationMode]="'notification'"
                    (onUploadStarted)="uploadStarted()"
                    (onFileCreated)="addToSelectedFiles([$event], true)"
                    [showHeader]="false"
                    [isDisabled]="isDisabled"
                    [targetFolderId]="targetFolderId"
                    [createTargetFolder]="createTargetFolder"
                    [datasetId]="datasetId"
                    class="file-upload pb-2"
                    [ngClass]="fileUploadHeightClass"
                    data-uit="workflow-starter-component-input-files-upload"
                ></ca-file-upload>
                <button
                    (click)="setWorkflowStarterType(WorkflowStarterType.FileExplorerApeerFiles)"
                    *ngIf="!hideApeerFileSelection"
                    class="btn btn-primary btn-block justify-content-start selection-method-btn mb-2"
                    data-uit="workflow-starter-selection-apeer-files"
                    type="button"
                >
                    <ca-icon name="folder" size="m"></ca-icon>
                    <span>{{ 'WORKFLOWS.RUNNER.SELECT_FILES_ON_ARIVIS_CLOUD' | translate }}</span>
                </button>
                <button
                    (click)="addUrl()"
                    *ngIf="!hideUrlUpload"
                    class="btn btn-primary btn-block justify-content-start selection-method-btn mb-2"
                    data-uit="workflow-starter-selection-web-files"
                    type="button"
                >
                    <ca-icon name="web" size="m"></ca-icon>
                    <span>{{ 'WORKFLOWS.RUNNER.SELECT_FILES_ON_WEB' | translate }}</span>
                </button>
                <button
                    (click)="addTestFiles()"
                    *ngIf="isPublicWorkflow && initiallySelectedFiles.length > 0"
                    class="btn btn-primary btn-block justify-content-start"
                    data-uit="workflow-starter-selection-test-files"
                    type="button"
                >
                    <ca-icon name="picture" size="m"></ca-icon>
                    <span>{{ 'WORKFLOWS.RUNNER.SELECT_TEST_FILES' | translate }}</span>
                </button>
            </div>
        </div>
    </div>
    <div class="col-md-6 h-100 right-column">
        <div class="select-workflow-starter-type-container" *ngIf="selectedFiles?.length === 0">
            <ng-container *ngIf="workflowStarterType === WorkflowStarterType.SelectionMethods">
                <ca-icon name="cloud--upload" size="m" [removeSVGAttributes]="[]"></ca-icon>
                {{ 'WORKFLOWS.RUNNER.CHOOSE_SELECTION_METHOD' | translate }}
            </ng-container>
            <ng-container *ngIf="workflowStarterType !== WorkflowStarterType.SelectionMethods">
                <ca-icon name="list-with-cursor-on-it" size="m" [removeSVGAttributes]="[]"></ca-icon>
                {{ 'WORKFLOWS.RUNNER.NO_FILES_SELECTED' | translate }}
            </ng-container>
        </div>
        <div data-uit="upload-selection" class="upload-selection h-100 w-100" *ngIf="selectedFiles?.length > 0">
            <ca-file-selection
                data-uit="selected-files-for-workflow"
                [flowId]="flowId"
                [isDisabled]="isRerun || isDisabled || isWorkflowRunning"
                [searchAndSortOptions]="searchAndSortOptionsForFileSelection"
                [selectedFiles]="selectedFiles"
                [showViewAllButton]="showViewAllButton"
                [showViewIconForSelectedItems]="!isWorkflowRunning"
                [isCziConversionInProgress]="isCziConversionInProgress"
                [numberOfConversionFailedFiles]="numberOfConversionFailedFiles"
                (onChangeSearchAndSortOptions)="updateSearchAndSortOptions($event)"
                (onRemoveAllFiles)="removeAllUploads()"
                (onRemoveFile)="removeUpload($event)"
                (onReset)="resetWorkflowStarter()"
                (onUpdateFileUrl)="updateFileUrl($event)"
                (onViewSelection)="toggleArivisPreviewer()"
            ></ca-file-selection>
        </div>
    </div>
</div>
<div [hidden]="!showArivisPreviewer" class="starter-wrapper-arivis-preview row h-100">
    <div class="arivis-select-cnt h-100 px-3 position-relative">
        <ca-file-selection
            #fileSelectionRef
            [filesSelectable]="true"
            [flowId]="flowId"
            [isDisabled]="isRerun || isDisabled || isWorkflowRunning"
            [searchAndSortOptions]="searchAndSortOptionsForFileSelection"
            [selectedFiles]="selectedFiles"
            [showFileSize]="false"
            [showViewAllButton]="showViewAllButton"
            [showPreviewMode]="true"
            [showViewIconForSelectedItems]="!isWorkflowRunning"
            [isCziConversionInProgress]="isCziConversionInProgress"
            [numberOfConversionFailedFiles]="numberOfConversionFailedFiles"
            (onAddFiles)="toggleArivisPreviewer()"
            (onChangeSearchAndSortOptions)="updateSearchAndSortOptions($event)"
            (onRemoveAllFiles)="removeAllUploads()"
            (onRemoveFile)="removeUpload($event)"
            (onReset)="resetWorkflowStarter()"
            (onSelectedFileChange)="handleSelectedFileChange($event)"
            (onUpdateFileUrl)="updateFileUrl($event)"
            data-uit="workflow-starter_selected-files"
        ></ca-file-selection>
    </div>
    <div class="arivis-preview-cnt h-100 px-3 position-relative" data-uit="arivis-preview-container">
        <ca-arivis-img-viewer
            *ngIf="isSelectedFileSupportedByArivis()"
            [file]="selectedPreviewFile"
            class="flex-grow-1 w-100 h-100 p-0"
            data-uit="arivis-img-viewer"
        ></ca-arivis-img-viewer>
        <ca-file-previewer *ngIf="!isSelectedFileSupportedByArivis() && isSelectedFileSupportedByFilePreviewer()" data-uit="file-previewer"></ca-file-previewer>
        <div class="arivis-nav d-flex justify-content-between" [ngClass]="{ invisible: selectedFiles.length >= 1 }">
            <button
                type="button"
                class="btn ca-btn-icon ca-btn-icon-big"
                [disabled]="isFirstIndex"
                (click)="handlePreviousNextFileClick('previous')"
                [title]="'WORKFLOWS.RUNNER.BUTTON.PREVIOUS_STEP' | translate"
            >
                <ca-icon name="arrow-left" size="s"></ca-icon>
            </button>
            <button
                type="button"
                class="btn ca-btn-icon ca-btn-icon-big"
                [disabled]="isLastIndex"
                (click)="handlePreviousNextFileClick('next')"
                [title]="'WORKFLOWS.RUNNER.BUTTON.NEXT_STEP' | translate"
            >
                <ca-icon name="arrow-right" size="s"></ca-icon>
            </button>
        </div>
    </div>
</div>
